'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Dropdown = require('react-bootstrap/lib/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _common = require('../../common');

var _containers = require('../../../containers');

var _SMSSavedReplyDropdownItem = require('./SMSSavedReplyDropdownItem');

var _SMSSavedReplyDropdownItem2 = _interopRequireDefault(_SMSSavedReplyDropdownItem);

var _AppConstants = require('../../../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var GuardedSaveSMSReplyMenuItem = (0, _containers.createGuardedContainer)({
  permissionName: _AppConstants2.default.PERMISSIONS.ADD_SMS_SAVED_REPLY,
  enabledComponent: _MenuItem2.default,
  disabledComponent: (0, _containers.createDisabledContainer)(_MenuItem2.default)
});

var SMSSavedReplyDropdown = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(SMSSavedReplyDropdown, _Component);

  function SMSSavedReplyDropdown() {
    _classCallCheck(this, SMSSavedReplyDropdown);

    return _possibleConstructorReturn(this, (SMSSavedReplyDropdown.__proto__ || Object.getPrototypeOf(SMSSavedReplyDropdown)).apply(this, arguments));
  }

  _createClass(SMSSavedReplyDropdown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dropdownButtonId = _props.dropdownButtonId,
          onDeleteSMSSavedReply = _props.onDeleteSMSSavedReply,
          onSaveSMSReplyClick = _props.onSaveSMSReplyClick,
          onSMSSavedReplyClick = _props.onSMSSavedReplyClick,
          smsSavedReplies = _props.smsSavedReplies;


      return _react2.default.createElement(
        _Dropdown2.default,
        { id: dropdownButtonId },
        _react2.default.createElement(
          _Dropdown2.default.Toggle,
          {
            className: 'no-padding',
            bsStyle: 'link',
            bsSize: 'small'
          },
          _react2.default.createElement(_common.Icon, { type: 'file-text-o' }),
          ' Saved Messages'
        ),
        _react2.default.createElement(
          _Dropdown2.default.Menu,
          null,
          _react2.default.createElement(
            GuardedSaveSMSReplyMenuItem,
            { className: 'add', onClick: onSaveSMSReplyClick },
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
              ' Add New Message'
            )
          ),
          !!smsSavedReplies.length && _react2.default.createElement(_MenuItem2.default, { divider: true }),
          smsSavedReplies.map(function (reply) {
            return _react2.default.createElement(_SMSSavedReplyDropdownItem2.default, {
              onSMSSavedReplyClick: onSMSSavedReplyClick,
              onDeleteSMSSavedReply: onDeleteSMSSavedReply,
              smsSavedReply: reply,
              key: reply.id
            });
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return SMSSavedReplyDropdown;
}(_react.Component), _class2.propTypes = {
  dropdownButtonId: _propTypes2.default.string.isRequired,
  onDeleteSMSSavedReply: _propTypes2.default.func.isRequired,
  onSaveSMSReplyClick: _propTypes2.default.func.isRequired,
  onSMSSavedReplyClick: _propTypes2.default.func.isRequired,
  smsSavedReplies: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class;

var _default = SMSSavedReplyDropdown;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GuardedSaveSMSReplyMenuItem, 'GuardedSaveSMSReplyMenuItem', '/app/src/components/page-case/sidebar-feed/SMSSavedReplyDropdown.jsx');
  reactHotLoader.register(SMSSavedReplyDropdown, 'SMSSavedReplyDropdown', '/app/src/components/page-case/sidebar-feed/SMSSavedReplyDropdown.jsx');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/sidebar-feed/SMSSavedReplyDropdown.jsx');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS9zaWRlYmFyLWZlZWQvU01TU2F2ZWRSZXBseURyb3Bkb3duLmpzeCJdLCJuYW1lcyI6WyJHdWFyZGVkU2F2ZVNNU1JlcGx5TWVudUl0ZW0iLCJwZXJtaXNzaW9uTmFtZSIsIkFwcENvbnN0YW50cyIsIlBFUk1JU1NJT05TIiwiQUREX1NNU19TQVZFRF9SRVBMWSIsImVuYWJsZWRDb21wb25lbnQiLCJNZW51SXRlbSIsImRpc2FibGVkQ29tcG9uZW50IiwiU01TU2F2ZWRSZXBseURyb3Bkb3duIiwiYXV0b0JpbmRNZXRob2RzIiwib2JzZXJ2ZXIiLCJwcm9wcyIsImRyb3Bkb3duQnV0dG9uSWQiLCJvbkRlbGV0ZVNNU1NhdmVkUmVwbHkiLCJvblNhdmVTTVNSZXBseUNsaWNrIiwib25TTVNTYXZlZFJlcGx5Q2xpY2siLCJzbXNTYXZlZFJlcGxpZXMiLCJsZW5ndGgiLCJtYXAiLCJyZXBseSIsImlkIiwiQ29tcG9uZW50IiwicHJvcFR5cGVzIiwiUHJvcFR5cGVzIiwic3RyaW5nIiwiaXNSZXF1aXJlZCIsImZ1bmMiLCJvYmplY3QiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7Ozs7Ozs7Ozs7OztBQU9BOztBQUNBOztBQUVBOzs7O0FBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdBLElBQU1BLDhCQUE4Qix3Q0FBdUI7QUFDekRDLGtCQUFnQkMsdUJBQWFDLFdBQWIsQ0FBeUJDLG1CQURnQjtBQUV6REMsb0JBQWtCQyxrQkFGdUM7QUFHekRDLHFCQUFtQix5Q0FBd0JELGtCQUF4QjtBQUhzQyxDQUF2QixDQUFwQzs7SUFTTUUscUIsT0FGTEMsZ0MsZUFDQUMsbUI7Ozs7Ozs7Ozs7OzZCQUdXO0FBQUEsbUJBT0osS0FBS0MsS0FQRDtBQUFBLFVBRU5DLGdCQUZNLFVBRU5BLGdCQUZNO0FBQUEsVUFHTkMscUJBSE0sVUFHTkEscUJBSE07QUFBQSxVQUlOQyxtQkFKTSxVQUlOQSxtQkFKTTtBQUFBLFVBS05DLG9CQUxNLFVBS05BLG9CQUxNO0FBQUEsVUFNTkMsZUFOTSxVQU1OQSxlQU5NOzs7QUFTUixhQUNFO0FBQUMsMEJBQUQ7QUFBQSxVQUFVLElBQUlKLGdCQUFkO0FBQ0U7QUFBQyw0QkFBRCxDQUFVLE1BQVY7QUFBQTtBQUNFLHVCQUFVLFlBRFo7QUFFRSxxQkFBUSxNQUZWO0FBR0Usb0JBQU87QUFIVDtBQUtFLHdDQUFDLFlBQUQsSUFBTSxNQUFLLGFBQVgsR0FMRjtBQUFBO0FBQUEsU0FERjtBQVFFO0FBQUMsNEJBQUQsQ0FBVSxJQUFWO0FBQUE7QUFDRTtBQUFDLHVDQUFEO0FBQUEsY0FBNkIsV0FBVSxLQUF2QyxFQUE2QyxTQUFTRSxtQkFBdEQ7QUFDRTtBQUFBO0FBQUE7QUFBTSw0Q0FBQyxZQUFELElBQU0sTUFBSyxlQUFYLEdBQU47QUFBQTtBQUFBO0FBREYsV0FERjtBQUlHLFdBQUMsQ0FBQ0UsZ0JBQWdCQyxNQUFsQixJQUE0Qiw4QkFBQyxrQkFBRCxJQUFVLGFBQVYsR0FKL0I7QUFLR0QsMEJBQWdCRSxHQUFoQixDQUFvQjtBQUFBLG1CQUNqQiw4QkFBQyxtQ0FBRDtBQUNFLG9DQUFzQkgsb0JBRHhCO0FBRUUscUNBQXVCRixxQkFGekI7QUFHRSw2QkFBZU0sS0FIakI7QUFJRSxtQkFBS0EsTUFBTUM7QUFKYixjQURpQjtBQUFBLFdBQXBCO0FBTEg7QUFSRixPQURGO0FBeUJEOzs7Ozs7Ozs7OztFQXBDaUNDLGdCLFdBc0MzQkMsUyxHQUFZO0FBQ2pCVixvQkFBa0JXLG9CQUFVQyxNQUFWLENBQWlCQyxVQURsQjtBQUVqQloseUJBQXVCVSxvQkFBVUcsSUFBVixDQUFlRCxVQUZyQjtBQUdqQlgsdUJBQXFCUyxvQkFBVUcsSUFBVixDQUFlRCxVQUhuQjtBQUlqQlYsd0JBQXNCUSxvQkFBVUcsSUFBVixDQUFlRCxVQUpwQjtBQUtqQlQsbUJBQWlCTyxvQkFBVUksTUFBVixDQUFpQkY7QUFMakIsQzs7ZUFTTmpCLHFCOzs7Ozs7Ozs7OzswQkF4RFRSLDJCOzBCQVNBUSxxQiIsImZpbGUiOiJTTVNTYXZlZFJlcGx5RHJvcGRvd24uanN4Iiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IG9ic2VydmVyIH0gZnJvbSAnbW9ieC1yZWFjdCc7XG5pbXBvcnQgYXV0b0JpbmRNZXRob2RzIGZyb20gJ2NsYXNzLWF1dG9iaW5kLWRlY29yYXRvcic7XG5cbmltcG9ydCB7XG4gIERyb3Bkb3duLFxuICBNZW51SXRlbSxcbn0gZnJvbSAncmVhY3QtYm9vdHN0cmFwJztcblxuaW1wb3J0IHsgSWNvbiB9IGZyb20gJy4uLy4uL2NvbW1vbic7XG5pbXBvcnQgeyBjcmVhdGVHdWFyZGVkQ29udGFpbmVyLCBjcmVhdGVEaXNhYmxlZENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uL2NvbnRhaW5lcnMnO1xuXG5pbXBvcnQgU01TU2F2ZWRSZXBseURyb3Bkb3duSXRlbSBmcm9tICcuL1NNU1NhdmVkUmVwbHlEcm9wZG93bkl0ZW0nO1xuXG5pbXBvcnQgQXBwQ29uc3RhbnRzIGZyb20gJy4uLy4uLy4uL2NvbnN0YW50cy9BcHBDb25zdGFudHMnO1xuXG5cbmNvbnN0IEd1YXJkZWRTYXZlU01TUmVwbHlNZW51SXRlbSA9IGNyZWF0ZUd1YXJkZWRDb250YWluZXIoe1xuICBwZXJtaXNzaW9uTmFtZTogQXBwQ29uc3RhbnRzLlBFUk1JU1NJT05TLkFERF9TTVNfU0FWRURfUkVQTFksXG4gIGVuYWJsZWRDb21wb25lbnQ6IE1lbnVJdGVtLFxuICBkaXNhYmxlZENvbXBvbmVudDogY3JlYXRlRGlzYWJsZWRDb250YWluZXIoTWVudUl0ZW0pLFxufSk7XG5cblxuQGF1dG9CaW5kTWV0aG9kc1xuQG9ic2VydmVyXG5jbGFzcyBTTVNTYXZlZFJlcGx5RHJvcGRvd24gZXh0ZW5kcyBDb21wb25lbnQge1xuXG4gIHJlbmRlciAoKSB7XG4gICAgY29uc3Qge1xuICAgICAgZHJvcGRvd25CdXR0b25JZCxcbiAgICAgIG9uRGVsZXRlU01TU2F2ZWRSZXBseSxcbiAgICAgIG9uU2F2ZVNNU1JlcGx5Q2xpY2ssXG4gICAgICBvblNNU1NhdmVkUmVwbHlDbGljayxcbiAgICAgIHNtc1NhdmVkUmVwbGllcyxcbiAgICB9ID0gdGhpcy5wcm9wcztcblxuICAgIHJldHVybiAoXG4gICAgICA8RHJvcGRvd24gaWQ9e2Ryb3Bkb3duQnV0dG9uSWR9PlxuICAgICAgICA8RHJvcGRvd24uVG9nZ2xlXG4gICAgICAgICAgY2xhc3NOYW1lPSduby1wYWRkaW5nJ1xuICAgICAgICAgIGJzU3R5bGU9J2xpbmsnXG4gICAgICAgICAgYnNTaXplPSdzbWFsbCdcbiAgICAgICAgPlxuICAgICAgICAgIDxJY29uIHR5cGU9J2ZpbGUtdGV4dC1vJyAvPiBTYXZlZCBNZXNzYWdlc1xuICAgICAgICA8L0Ryb3Bkb3duLlRvZ2dsZT5cbiAgICAgICAgPERyb3Bkb3duLk1lbnU+XG4gICAgICAgICAgPEd1YXJkZWRTYXZlU01TUmVwbHlNZW51SXRlbSBjbGFzc05hbWU9J2FkZCcgb25DbGljaz17b25TYXZlU01TUmVwbHlDbGlja30+XG4gICAgICAgICAgICA8c3Bhbj48SWNvbiB0eXBlPSdwbHVzLXNxdWFyZS1vJyAvPiBBZGQgTmV3IE1lc3NhZ2U8L3NwYW4+XG4gICAgICAgICAgPC9HdWFyZGVkU2F2ZVNNU1JlcGx5TWVudUl0ZW0+XG4gICAgICAgICAgeyEhc21zU2F2ZWRSZXBsaWVzLmxlbmd0aCAmJiA8TWVudUl0ZW0gZGl2aWRlciAvPn1cbiAgICAgICAgICB7c21zU2F2ZWRSZXBsaWVzLm1hcChyZXBseSA9PiAoXG4gICAgICAgICAgICAgIDxTTVNTYXZlZFJlcGx5RHJvcGRvd25JdGVtXG4gICAgICAgICAgICAgICAgb25TTVNTYXZlZFJlcGx5Q2xpY2s9e29uU01TU2F2ZWRSZXBseUNsaWNrfVxuICAgICAgICAgICAgICAgIG9uRGVsZXRlU01TU2F2ZWRSZXBseT17b25EZWxldGVTTVNTYXZlZFJlcGx5fVxuICAgICAgICAgICAgICAgIHNtc1NhdmVkUmVwbHk9e3JlcGx5fVxuICAgICAgICAgICAgICAgIGtleT17cmVwbHkuaWR9XG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgKSl9XG4gICAgICAgIDwvRHJvcGRvd24uTWVudT5cbiAgICAgIDwvRHJvcGRvd24+XG4gICAgKTtcbiAgfVxuXG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgZHJvcGRvd25CdXR0b25JZDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICAgIG9uRGVsZXRlU01TU2F2ZWRSZXBseTogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgICBvblNhdmVTTVNSZXBseUNsaWNrOiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICAgIG9uU01TU2F2ZWRSZXBseUNsaWNrOiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICAgIHNtc1NhdmVkUmVwbGllczogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICB9O1xufVxuXG5leHBvcnQgZGVmYXVsdCBTTVNTYXZlZFJlcGx5RHJvcGRvd247XG4iXX0=